export default {
	info: 'Informatsioon',
	modal: {
		title: 'Rollide õiguste selgitus',
		p1: 'Õigused määravad, mida kasutaja Cybsise tarkvaras näeb ja teha saab.',
		p2: 'Õigused kasutajatele antakse rollide kaudu: kõigepealt luuakse uus roll, valitakse rolli õigused ja seejärel lisatakse kasutaja sellesse rolli.',
		actionsTitle: 'On neli peamist tegevust:',
		actions: {
			view: 'Vaata (k.a andmete eksportimine)',
			edit: 'Muuda',
			add: 'Lisa',
			delete: 'Kustuta',
		},
		permissionsTitle: 'Õigused jagunevad kahte moodi:',
		own: 'Oma: Saad teha tegevusi objektidega, mille vastutajaks kasutaja/roll on määratud.',
		all: 'Kõik: Saad teha tegevusi kõikide andmetega.',
		legend: 'X tähistab õiguse puudumist ja ON tähistab, et õigus funktsionaalsust kasutada on sisse lülitatud.',
		autoRights1: 'Automaatsed vastutaja õigused',
		autoRights2:
			' - kui kasutaja vastutab millegi eest (nt äriprotsessi, mooduli või vara/infovara), siis näeb vastutaja sellega seotud andmeid juhul kui nendele seoste objektidele on antud vähemalt OMA vaatamise õigused.',
		example:
			'Näide: Äriprotsessiga on seotud vara, äriprotsessi vastutajale on antud varade OMA vaatamise õigus. Äriprotsessi vastutaja näeb sellisel juhul ka antud vara.',
		admin1: 'Administraatori õigused',
		admin2: ' on eraldi õigused, mis sisaldavad tarkvara üldiseid seadeid.',
	},
	missingRights: 'Puuduvad õigused',
}
